import type { Action } from 'redux';
import dash_api from '../../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import type { GetGoogleAuthenticationUrlPayload } from '../MarketingPlatform/GoogleMarketingPlatform.types';

const GetGoogleAuthenticationUrl = new ReduxAsyncAction<
  'GET_GOOGLE_AUTHENTICATION_URL',
  { scope: String; machineName: String; multiAuth?: boolean },
  GetGoogleAuthenticationUrlPayload
>('GET_GOOGLE_AUTHENTICATION_URL');
GetGoogleAuthenticationUrl.registerRequest(({ scope, machineName, multiAuth }) => {
  return dash_api
    .get(`/v1/google/auth-url?scope=${scope}&machine_name=${machineName}&multi_auth=${multiAuth}`)
    .then(({ data }) => {
      return data;
    });
});
export const GET_GOOGLE_AUTHENTICATION_URL = GetGoogleAuthenticationUrl.actionNamespaceConstants;
export const getGoogleAuthenticationUrl = GetGoogleAuthenticationUrl.request;

export type GetGoogleAuthenticationUrlAction = Action<typeof GET_GOOGLE_AUTHENTICATION_URL.response> & {
  data: GetGoogleAuthenticationUrlPayload;
};
